import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 40px;
  padding-left: 0;
  padding-right: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  ${(props) => {
    const { getMedias: { iphones } } = props.theme;
    return `
    ${iphones()`
      display: flex;
      justify-content: center;
      margin-top: 1rem;
      margin-bottom: 1rem;
        `
    }
    `;
  }}
`;

export const UserPanelContainer = styled.div`
  width: 100%;
  max-width: 100%;
  align-self: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding: 5px 12px 5px 5px;
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border: 1px solid rgba(21, 43, 78, 0.1);
  box-shadow: 0 3px 12px rgba(21, 43, 78, 0.08);

  ${(props) => {
    const { getMedias: { iphones } } = props.theme;
    return `
    ${iphones()`
      width: calc(100% - 8px);
      align-items: center;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      gap: 6px;
      margin: 0 0 42px 0;
      padding: 7px 10px 7px 5px;
      top: 0;
      margin-bottom: 0;
        `
    }
    `;
  }}
`;

export const BoxNotification = styled.div`
  align-self: center;
  flex: 0 0 auto;
  margin-right: 0;

  & > ul {
    display: none;
  }

  & > div > svg {
    &:hover {
      ul < div < & {
        display: block;
      }
    }
  }
`;

export const BoxWelcome = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  flex: 1 1 auto;
  min-width: 0;

  & > div:last-child {
    & > ul { display: none; }
  }
`;

export const BoxExit = styled.div`
  align-self: center;
  flex: 0 0 auto;
  padding-left: 10px;
  border-left: 1px solid rgba(21, 43, 78, 0.12);

  ${(props) => {
    const { getMedias: { iphones } } = props.theme;
    return `
    ${iphones()`
      margin: 40px 0 0 108px;
      `
    }
  `;
  }};
`;

export const ContainerIcons = styled.div`
  width: 10px;
  position: relative;
  cursor: pointer;
`;

export const NotifyContainer = styled.div`
  position: absolute;
  top: -2px;
  right: 3px;
  width: 10px;
  height: 10px;

  & > svg { 
    width: .8rem;

    & > text { 
      font-size: 570px;
      font-family: 'Calibri'; 
    }
  }
`;

export const ContaineGuestIcon = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #f1f6ff;
  border: 1px solid rgba(21, 43, 78, 0.12);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  & > svg {
    width: 22px;
    height: 22px;

    & > circle, & > path {
      fill: none;
      stroke: #6b7c93;
      stroke-width: 30;
    }
  }
`;

export const ContainerInfoUser = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: baseline;
  padding-left: 0.1rem;
  align-self: center;
  gap: 0.3rem;
  min-width: 0;
  white-space: nowrap;
`;

export const SpanHello = styled.span`
  color: #7d8aa3;
  font-size: 0.8125rem;
  line-height: 1.2;
  letter-spacing: 0.02em;
  flex-shrink: 0;
`;
  
export const NameUser = styled.a`
  color: #152b4e !important;
  font-weight: 700;
  padding-right: 0 !important;
  font-size: 13px;
  line-height: 1.2;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:after {
    width: 10px;
    height: 4px;
  }
`;

export const ExitIconContainer = styled.div`
  width: auto;
  font-size: 11px;
  line-height: 1;
  color: #6b7c93;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  transition: color .2s ease, transform .2s ease;

  & > svg {
    width: 14px;
    height: 14px;

    & > path {
      fill: #6b7c93;
    }
  }

  &:hover {
    color: #152b4e;
    transform: translateY(-1px);

    & > svg > path {
      fill: #152b4e;
    }
  }
`;
